/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Image, Anchor } from "hesus-ui-kit";
import {
  FormBody,
  OptionsWrapper,
  FlexRow,
  SectionContainer,
  OuterWrapper,
  RowTitleText,
  WrapperStatus,
  ContactDetail,
  ButtonData,
  CompanyDetail,
  ActiveButton,
  InActiveButton,
  PendingButton,
  CommunicationDetail,
  EmailDetail,
  PhoneDetail,
  CommunicationOuterWrapper,
  PlatformNotExist,
  PlatformExist,
  EditorDescription,
  EditorDescriptionWrapper,
  EditorDescriptionTitle,
} from "./RelatedContactView.styled";
import { avatarIcons, avatarIconsMr, avatarIconsMs } from "@utils/avatarInfo";
import LinkedEntityList from "../../Contact/ContactView/components/LinkedEntityList";
import emailIcon from "@icons/ic-email.svg";
import phoneIcon from "@icons/ic-phone.svg";
import mobilePhoneIcon from "@icons/ic-mobile-phone.svg";
import platformIcon from "@icons/ic-platform.svg";
import noPlatformIcon from "@icons/ic-platform-no.svg";

const RelatedContactView = (props) => {
  const { t, relatedContactInfo } = props;
  const courtseyText = { "": "", MISTER: "Mr", MISS: "Mrs" };
  const [avatarImage, setAvatarImage] = useState(avatarIcons[1]);
  const avatarNumber = Math.floor(Math.random() * 10);

  useEffect(() => {
    if (relatedContactInfo?.contact?.courtesy === "MISTER") {
      setAvatarImage(avatarIconsMr[avatarNumber] ?? avatarIcons[1]);
    } else if (relatedContactInfo?.contact?.courtesy === "MISS") {
      setAvatarImage(avatarIconsMs[avatarNumber] ?? avatarIcons[4]);
    } else {
      setAvatarImage(avatarIcons[avatarNumber] ?? avatarIcons[1]);
    }
  }, []);

  return (
    <FormBody>
      <OptionsWrapper>
        <FlexRow>
          <SectionContainer>
            <OuterWrapper>
              <Image
                src={avatarImage}
                alt="Avatar"
                className="related_contact-notes-view__avatar-icon"
              />
              <ContactDetail>
                <RowTitleText>
                  {relatedContactInfo?.contact?.courtesy !== null &&
                    courtseyText[relatedContactInfo?.contact?.courtesy] + " "}
                  {relatedContactInfo?.contact?.firstName +
                    " " +
                    relatedContactInfo?.contact?.lastName}
                </RowTitleText>
                <CompanyDetail>
                  {relatedContactInfo?.contact?.job !== null &&
                    relatedContactInfo?.contact?.job + " "}
                  {relatedContactInfo?.contact?.company !== null &&
                    relatedContactInfo?.contact?.job !== null &&
                    t("GENERAL_AT") + " "}
                  {relatedContactInfo?.contact?.company !== null && (
                    <Link
                      to={`/company/view/${relatedContactInfo?.contact?.company.id}`}
                    >
                      {relatedContactInfo?.contact?.company.name}
                    </Link>
                  )}
                </CompanyDetail>
                <WrapperStatus>
                  {relatedContactInfo?.relatedContactRoles !== null &&
                    relatedContactInfo?.relatedContactRoles?.map(
                      (role, index) => {
                        return (
                          <ButtonData
                            key={"linkedentity-" + role.id + "-" + index}
                          >{`${t(role.roleLabel)}`}</ButtonData>
                        );
                      }
                    )}
                </WrapperStatus>
              </ContactDetail>
              <WrapperStatus>
                {relatedContactInfo?.contact?.status === 1 && (
                  <ActiveButton>{t("ACTIVE")}</ActiveButton>
                )}
                {relatedContactInfo?.contact?.status === 2 && (
                  <InActiveButton>{t("INACTIVE")}</InActiveButton>
                )}
                {relatedContactInfo?.contact?.status === null && (
                  <PendingButton>{t("PENDING")}</PendingButton>
                )}
              </WrapperStatus>
            </OuterWrapper>
            <CommunicationOuterWrapper>
              <CommunicationDetail>
                {relatedContactInfo?.contact?.email !== null &&
                  relatedContactInfo?.contact?.email !== "" && (
                    <EmailDetail>
                      <Image
                        src={emailIcon}
                        alt={t("EMAIL")}
                        title={t("EMAIL")}
                        className="related_contact-notes-view__image-communication-icon"
                      />
                      <Anchor
                        url={`mailto:${relatedContactInfo?.contact?.email}`}
                      >
                        {relatedContactInfo?.contact?.email}
                      </Anchor>
                      <br></br>
                    </EmailDetail>
                  )}
                <PhoneDetail>
                  {relatedContactInfo?.contact?.mobilePhone !== null &&
                    relatedContactInfo?.contact?.mobilePhone !== "" && (
                      <>
                        <Image
                          src={mobilePhoneIcon}
                          alt={t("MOBILE")}
                          title={t("MOBILE")}
                          className="related_contact-notes-view__image-communication-icon"
                        />
                        {relatedContactInfo?.contact?.mobilePhone}
                      </>
                    )}
                  {relatedContactInfo?.contact?.phone !== null &&
                    relatedContactInfo?.contact?.phone !== "" && (
                      <>
                        <Image
                          src={phoneIcon}
                          alt={t("PHONE")}
                          title={t("PHONE")}
                          className="related_contact-notes-view__image-communication-icon"
                        />
                        {relatedContactInfo?.contact?.phone}
                      </>
                    )}
                </PhoneDetail>
              </CommunicationDetail>
              <WrapperStatus>
                {!relatedContactInfo?.contact?.isPlatfrom && (
                  <PlatformNotExist>
                    <Image
                      src={noPlatformIcon}
                      alt={t("PLATFORM")}
                      title={t("PLATFORM")}
                      className="related_contact-notes-view__image-communication-icon"
                    />
                    {t("CONTACT_IS_USER")}
                  </PlatformNotExist>
                )}
                {relatedContactInfo?.contact?.isPlatfrom && (
                  <PlatformExist>
                    <Image
                      src={platformIcon}
                      alt={t("PLATFORM")}
                      title={t("PLATFORM")}
                      className="related_contact-notes-view__image-communication-icon"
                    />
                    {t("CONTACT_IS_USER")}
                  </PlatformExist>
                )}
              </WrapperStatus>
            </CommunicationOuterWrapper>
            {relatedContactInfo?.contact?.comment !== null && (
              <>
                <EditorDescriptionWrapper>
                  <EditorDescriptionTitle>
                    {t("CONTACT_COMPLEMENTARY_INFO")}
                  </EditorDescriptionTitle>
                </EditorDescriptionWrapper>
                <EditorDescriptionWrapper>
                  <EditorDescription>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: relatedContactInfo?.contact?.comment,
                      }}
                    ></div>
                  </EditorDescription>
                </EditorDescriptionWrapper>
              </>
            )}
            {relatedContactInfo.contact.linkedEntities !== null &&
              relatedContactInfo.contact.linkedEntities.length > 0 && (
                <>
                  <EditorDescriptionWrapper>
                    <EditorDescriptionTitle>
                      {t("LINKED_ENTITIES")}
                    </EditorDescriptionTitle>
                  </EditorDescriptionWrapper>
                  <EditorDescriptionWrapper>
                    <LinkedEntityList
                      enitites={relatedContactInfo.contact.linkedEntities}
                    />
                  </EditorDescriptionWrapper>
                </>
              )}
          </SectionContainer>
        </FlexRow>
      </OptionsWrapper>
    </FormBody>
  );
};

RelatedContactView.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(RelatedContactView);
